import Vue from "vue";
import Router from "vue-router";
import Update from "@/components/login/update";
import detailIndex from "@/components/details/index";
import property from "@/components/details/property/property.vue";
import selection from "@/components/details/property/selection";
import write from "@/components/details/property/write";
import complete from "@/components/details/property/complete";
import price from "@/components/details/price/price";
import plans from "@/components/details/plans/plans";
import site from "@/components/details/site/site";
import schadule from "@/components/details/schadule/schadule";
import specifications from "@/components/details/specifications/specifications";
import appraisal from "@/components/details/appraisal/appraisal";
import fee from "@/components/details/fee/fee";
import valuation from "@/components/details/valuation/valuation.vue";
import looking from "@/components/details/looking/looking";
import Faq from "@/components/faq/faq";
import account from "@/components/account/account";
import edit from "@/components/account/edit.vue";
import book from "@/components/account/book";
import reserve from "@/components/account/reserve";
import purchase from "@/components/account/purchase";
import dtl from "@/components/account/purchaseDtl";
import reserveDtl from "@/components/account/reserveDtl";
import list from "@/components/account/list";
import inner from "@/components/account/inner";
import recommend from "@/components/account/recommend";
import invoice from "@/components/account/invoice";
import contact from "@/components/more/contact";
import term from "@/components/more/term";
import policy from "@/components/more/policy";
import term2 from "@/components/more/term2";
import policy2 from "@/components/more/policy2";
import affiliate from "@/components/more/affiliate";
import abous from "@/components/more/abous.vue";
/**************************************************/
import index2 from "@/components/private/index";
import property2 from "@/components/private/property/property";
import write2 from "@/components/private/property/write";
import selection2 from "@/components/private/property/selection";
import complete2 from "@/components/private/property/complete";
import price2 from "@/components/private/price/price";
import plans2 from "@/components/private/plans/plans";
import site2 from "@/components/private/site/site";
import schadule2 from "@/components/private/schadule/schadule";
import specifications2 from "@/components/private/specifications/specifications";
import appraisal2 from "@/components/private/appraisal/appraisal";
import fee2 from "@/components/private/fee/fee";
import valuation2 from "@/components/private/valuation/valuation.vue";
import looking2 from "@/components/private/looking/looking";
import construction from "@/components/private/construction/list";
import construction2 from "@/components/private/construction/inner";
import MainLayout from "../components/home/mainLayout.vue";
import SearchLayout from "../components/search/searchLayout.vue";
import DetailsLayout from "../components/propertyDetails/detailsLayout.vue";
import ReservationLayout from "../components/reservation/reservationLayout.vue";
import ConfirmationLayout from "../components/reservation/confirm/confirmationLayout.vue";
import SelectionFormLayout from "../components/reservation/form/selectionFormLayout.vue";
import ContactUsLayout from "../components/contact/contactUsLayout.vue";
import loginLayout from "../components/login/loginLayout.vue";
import registrationLayout from "../components/register/registrationLayout.vue";
import passwordResetLayout from "../components/reset/passwordResetLayout.vue";
import passwordResetSuccessfulLayout from "../components/reset/passwordResetSuccessfulLayout.vue";
import passwordResetLinkExpiredLayout from "../components/reset/passwordResetLinkExpiredLayout.vue";
import profilePage from "../components/profile/profilePage.vue";
import aboutUsLayout from "../components/about/aboutUsLayout.vue";
import howItWorksLayout from "../components/howItWorks/howItWorksLayout.vue";
import blogLayout from "../components/blog/blogLayout.vue";
import blogView from "../components/blog/blogView.vue";
import agentRegistrationLayout from "../components/register/agentRegistration/agentRegistrationLayout.vue";
import termsAndConditionsLayout from "../components/terms/termsAndConditionsLayout.vue";
import privacyPolicyLayout from "../components/privacyPolicy/privacyPolicyLayout.vue";
import advertiseWithUsLayout from "../components/advertiseWithUs/advertiseWithUsLayout.vue";
/**************************************************/

import uConnectRegistrationLayout from "../components/register/uConnectRegistration/uConnectRegistrationLayout.vue";
import uConnectSubscriptionStepsLayout
    from "../components/register/uConnectRegistration/steps/uConnectSubscriptionStepsLayout.vue";
import uConnectSelectPlanStep
    from "../components/register/uConnectRegistration/selectPackage/uConnectSelectPlanStep.vue";
import uConnectUserDetailsStep
    from "../components/register/uConnectRegistration/steps/userDetailsSteps/uConnectUserDetailsStep.vue";
import uConnectSetPasswordStep
    from "../components/register/uConnectRegistration/steps/userDetailsSteps/uConnectSetPasswordStep.vue";
import uConnectMoreUserDetailsStep
    from "../components/register/uConnectRegistration/steps/userDetailsSteps/uConnectMoreUserDetailsStep.vue";
import uConnectTnCStep from "../components/register/uConnectRegistration/steps/userDetailsSteps/uConnectTnCStep.vue";
import uConnectPaymentStep from "../components/register/uConnectRegistration/steps/paymentSteps/uConnectPaymentStep.vue";
import uConnectSuccessStep from "../components/register/uConnectRegistration/steps/paymentSteps/uConnectSuccessStep.vue";
import uConnectSelectPlanDetailsStep
    from "../components/register/uConnectRegistration/selectPackage/uConnectSelectPlanDetailsStep.vue";
import agentRegistrationLayoutInterim
  from "../components/register/agentRegistration/agentRegistrationLayout-Interim.vue";
import MainLayoutInterim from "../components/home/mainLayout-Interim.vue";
/**************************************************/

Vue.use(Router);

const router = new Router({
  routes: [
    // loginPage
    // {
    //   path: "/login",
    //   name: "newloginpage",
    //   component: loginLayout,
    //   meta: { requireAuth: false }
    // },
    // frontPage
    {
      path: "/",
      name: "mainIndex",
      component: MainLayoutInterim,
      meta: { requireAuth: false }
    },
    // catch-all route
    {
      path: '*',
      redirect: '/'
    },
    // home page
    {
      path: "/homepage",
      name: "mainIndexHome",
      component: MainLayoutInterim,
      meta: { requireAuth: false }
    },

    // {
    //   path: "/profile",
    //   component: profilePage,
    //   meta: { requireAuth: true },
    //   name: "profilepage"
    // },
    // search page
    // {
    //   path: "/property/search/results",
    //   name: "searchIndex",
    //   component: SearchLayout,
    //   meta: { requireAuth: false, keepAlive: true }
    // },
    // property details page
    // {
    //   path: "/property-details/view",
    //   name: "propertyDetailsIndex",
    //   component: DetailsLayout,
    //   meta: { requireAuth: false }
    // },
    // reserve property selection page
    // {
    //   path: "/property/reservation",
    //   name: "reservePropertyIndex",
    //   component: ReservationLayout,
    //   meta: { requireAuth: false }
    // },
    // reserve property form page
    // {
    //   path: "/property/form",
    //   name: "reservePropertyFormIndex",
    //   component: SelectionFormLayout,
    //   meta: { requireAuth: false }
    // },

    // reserve property confirmation page
    // {
    //   path: "/property/reserve/confirm",
    //   name: "reservePropertyConfirmIndex",
    //   component: ConfirmationLayout,
    //   meta: { requireAuth: false }
    // },

    // contact us page
    // {
    //   path: "/contactus",
    //   name: "contactUsPageIndex",
    //   component: ContactUsLayout,
    //   meta: { requireAuth: false }
    // },

    // about us page
    // {
    //   path: "/about",
    //   name: "aboutUsPageIndex",
    //   component: aboutUsLayout,
    //   meta: { requireAuth: false }
    // },

    // how it works page
    // {
    //   path: "/how-it-works",
    //   name: "how-it-works-page-index",
    //   component: howItWorksLayout,
    //   meta: { requireAuth: false }
    // },
    // {
    //   path: "/advertise-with-unifi-property-com",
    //   name: "advertise-with-unifi-property-com",
    //   component: advertiseWithUsLayout,
    //   meta: { requireAuth: false }
    //
    // },
    // privacy policy page
    // {
    //   path: "/privacyPolicy",
    //   name: "privacyPolicy",
    //   component: privacyPolicyLayout,
    //   meta: { requireAuth: false }
    // },
/*    {
      path: "/agents",
      component: agentRegistrationLayout,
      meta: { requireAuth: false },
      name: "agents"
    },*/
    {
      path: "/agents",
      component: agentRegistrationLayoutInterim,
      meta: { requireAuth: false },
      name: "agents"
    },
    {
      path: "/pricing",
      component: uConnectRegistrationLayout,
      meta: { requireAuth: false },
      name: "uconnect"
    },
    {
      path: "/unifi/register/",
      component: uConnectSubscriptionStepsLayout,
      children: [
        {
          path: "select-plan",
          component: uConnectSelectPlanStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectSelectPlanStep"
        },
        {
          path: "select-plan-details",
          component: uConnectSelectPlanDetailsStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectSelectPlanDetailsStep"
        },
        {
          path: "user-details",
          component: uConnectUserDetailsStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectUserDetailsStep"
        },
        {
          path: "user-details-password",
          component: uConnectSetPasswordStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectSetPasswordStep"
        },
        {
          path: "more-details",
          component: uConnectMoreUserDetailsStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectMoreUserDetailsStep"
        },

        {
          path: "tnc",
          component: uConnectTnCStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectTnCStep"
        },
        {
          path: "payment",
          component: uConnectPaymentStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectPaymentStep"
        },
        {
          path: "confirm",
          component: uConnectSuccessStep,
          meta: { requireUConnectAuth: true },
          name: "uConnectSuccessStep"
        }
      ]

    },
    {
      path: "/blog",
      name: "blogPageIndex",
      component: blogLayout,
      meta: { requireAuth: false }
    },
    {
      path: "/blog/view/:id",
      name: "blogViewPageIndex",
      component: blogView,
      meta: { requireAuth: false }
    },

    // login page
    // {
    //   path: "/newlogin",
    //   name: "newLoginIndex",
    //   component: loginLayout,
    //   meta: { requireAuth: false }
    // },
    // registration page
    // {
    //   path: "/register",
    //   name: "registerIndex",
    //   component: registrationLayout,
    //   meta: { requireAuth: false }
    // },

    // password reset page
    // {
    //   path: "/password/reset",
    //   name: "passwordResetIndex",
    //   component: passwordResetLayout,
    //   meta: { requireAuth: false }
    // },
    // password reset success page
    // {
    //   path: "/password/success",
    //   name: "passwordResetSuccessIndex",
    //   component: passwordResetSuccessfulLayout,
    //   meta: { requireAuth: false }
    // },
    // password reset link expired page
    // {
    //   path: "/password/expired",
    //   name: "passwordResetExpiredIndex",
    //   component: passwordResetLinkExpiredLayout,
    //   meta: { requireAuth: false }
    // },

    // updatePasswordPage
    // {
    //   path: "/update",
    //   component: Update,
    //   meta: { requireAuth: false }
    // },
    // terms and conditions page
    // {
    //   path: "/terms-and-conditions",
    //   name: "termsAndConditionsPageIndex",
    //   component: termsAndConditionsLayout,
    //   meta: { requireAuth: false }
    // },
    // propertyDetailsModuleFramePage
    // {
    //   path: "/index",
    //   component: detailIndex,
    //   children: [
    //     {
    //       path: "property/:id/:roomId/:operate",
    //       component: property,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "price/:id/:roomId/:operate",
    //       component: price,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "plans/:id/:roomId/:operate",
    //       component: plans,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "site/:id/:roomId/:operate",
    //       component: site,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "schadule/:id/:roomId/:operate",
    //       component: schadule,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "specificate/:id/:roomId/:operate",
    //       component: specifications,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "appraisal/:id/:roomId/:operate",
    //       component: appraisal,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "fee/:id/:roomId/:operate",
    //       component: fee,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "valuation/:id/:roomId/:operate",
    //       component: valuation,
    //       meta: { requireAuth: true }
    //     },
    //     {
    //       path: "looking/:id/:roomId/:operate",
    //       component: looking,
    //       meta: { requireAuth: true }
    //     }
    //   ]
    // },
    // {
    //   path: "/property/selection/:id",
    //   component: selection,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/property/write/:id/:roomId",
    //   component: write,
    //   name: "write",
    //   meta: {
    //     requireAuth: true,
    //     keepAlive: true
    //   }
    // },
    // {
    //   path: "/property/complete",
    //   component: complete,
    //   name: "propertyComplete",
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/faq",
    //   name: "faq",
    //   component: Faq,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account",
    //   component: account,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/edit",
    //   component: edit,
    //   meta: { requireAuth: true },
    //   name: "edit"
    // },
    // {
    //   path: "/account/book",
    //   component: book,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/reserve",
    //   component: reserve,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/reserved/:id/:roomId/:orderId",
    //   component: reserveDtl,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/purchase",
    //   component: purchase,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/purchased/:id/:roomId/:orderId",
    //   component: dtl,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/list/:id",
    //   component: list,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/inner/:constructionId/:checkId/:one/:tow/:three",
    //   component: inner,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/recommend/:id",
    //   component: recommend,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/account/invoice",
    //   component: invoice,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/contact",
    //   component: contact,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/term",
    //   component: term,
    //   meta: { requireAuth: false }
    // },
    // {
    //   path: "/policy",
    //   component: policy,
    //   meta: { requireAuth: false }
    // },
    // {
    //   path: "/term2",
    //   component: term2,
    //   meta: { requireAuth: false }
    // },
    // {
    //   path: "/policy2",
    //   component: policy2,
    //   meta: { requireAuth: false }
    // },
    // {
    //   path: "/affiliate",
    //   component: affiliate,
    //   meta: { requireAuth: true }
    // },
    // {
    //   path: "/abous",
    //   component: abous,
    //   meta: { requireAuth: true }
    // },
    /**********************************************************************************/
    // {
    //   path: "/private",
    //   component: index2,
    //   children: [
    //     {
    //       path: "property/:id",
    //       component: property2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "selection/:id",
    //       component: selection2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "write/:id/:roomId",
    //       component: write2,
    //       meta: {
    //         requireAuth: false,
    //         keepAlive: true
    //       }
    //     },
    //     {
    //       path: "complete/:id/:roomId",
    //       component: complete2,
    //       name: "propertyComplete2",
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "price/:id",
    //       component: price2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "plans/:id",
    //       component: plans2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "site/:id",
    //       component: site2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "schadule/:id",
    //       component: schadule2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "specificate/:id",
    //       component: specifications2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "appraisal/:id",
    //       component: appraisal2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "fee/:id",
    //       component: fee2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "valuation/:id",
    //       component: valuation2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "looking/:id",
    //       component: looking2,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path: "construction/:id",
    //       component: construction,
    //       meta: { requireAuth: false }
    //     },
    //     {
    //       path:
    //         "construction/details/:id/:constructionId/:checkId/:one/:tow/:three",
    //       component: construction2,
    //       meta: { requireAuth: false }
    //     }
    //   ]
    // }
    /**********************************************************************************/
  ]
  // scrollBehavior(to, from, savedPosition) {
  // always scroll to top
  //   console.log("asdfasdf")
  //   return { top: 500 }
  // },
});
// 路由拦截
router.beforeEach((to, from, next) => {
  /* if (from.fullPath == '/login' && to.fullPath !== '/') {
    next('/login')
    return
  } */
  if (to.meta.requireAuth) {
    if (
      localStorage.getItem("token") !== null &&
      localStorage.getItem("token") !== "" &&
      localStorage.getItem("token") !== undefined
    ) {
      next();
    } else {
      next("/newlogin");
    }
  } else if (to.meta.requireUConnectAuth === true) {
    console.log("to",  to.path);
    console.log("to.meta.requireUConnectAuth " + to.meta.requireUConnectAuth);
    if (
      localStorage.getItem("uConnectRegistrationKey") !== null &&
      localStorage.getItem("uConnectRegistrationKey") !== "" &&
      localStorage.getItem("uConnectRegistrationKey") !== undefined
    ) {
      console.log("to-next",  next);
      next();
    } else {
      next("/uconnect");
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  ga("set", "page", to.path);
  ga("send", "pageview");
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js